<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>会议管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">会议管理</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="showAdd = true">
          <span>添加会议</span>
        </div>
      </div>
    </div>
    <div class="label">
      <div class="label-content" style="background: transparent">
        <Table
          :border="false"
          row-key="id"
          :columns="columns"
          :data="staffList"
          no-data-text="暂无数据"
        >
          <template slot-scope="{ row, index }" slot="scheduleName">{{
            row.scheduleName
          }}</template>
          <template slot-scope="{ row, index }" slot="scheduleAddress">{{
            row.scheduleAddress
          }}</template>
          <template slot-scope="{ row, index }" slot="preRegLink">{{
            row.preRegLink
          }}</template>
          <template slot-scope="{ row, index }" slot="beginTime">{{
            row.beginTime
          }}</template>
          <template slot-scope="{ row, index }" slot="endTime"
            >{{ row.endTime }}
          </template>
          <template slot-scope="{ row, index }" slot="meetingTime">{{
            row.meetingTime
          }}</template>
          <template slot-scope="{ row, index }" slot="detailedInformation">
            <div
              style="
                display: flex;
                align-items: center;
                padding: 10px 0;
                flex-wrap: wrap;
                justify-content: center;
              "
              v-if="row.detailedInformation"
              @click="
                visible = true;
                imgurl = row.detailedInformation;
              "
            >
              <img
                :src="row.detailedInformation"
                style="width: 60px; height: 60px; margin-bottom: 5px"
              />
            </div>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <span style="color: #1890ff; cursor: pointer" @click="editShow(row)"
              >编辑</span
            >
            <span style="display: inline-block; padding: 0 5px">|</span>
            <Poptip
              confirm
              title="确认是否删除?"
              @on-ok="delItem(row)"
              :transfer="true"
            >
              <span style="color: #f00; cursor: pointer">删除</span>
            </Poptip>
            <span style="display: inline-block; padding: 0 5px">|</span>
            <span
              style="color: #1890ff; cursor: pointer"
              @click="TableShow(row)"
              >查看统计</span
            >
          </template>
        </Table>
        <div
          class="my-page"
          v-if="totalCount > pageSize"
          style="margin: 20px; margin-bottom: 96px; text-align: center"
        >
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
      <!-- 修改展商置顶 -->
      <iModal
        title="编辑会议"
        v-model="editShowFlag"
        class-name="vertical-center-modal"
        width="800px"
        :mask-closable="false"
        @on-cancel="cancel"
      >
        <div class="admin-add">
          <div class="admin-add-content">
            <Form
              ref="formInline"
              :model="formInline"
              :rules="ruleInline"
              label-position="right"
              :label-width="100"
              @submit.native.prevent
            >
              <FormItem label="会议名称：">
                <Input
                  v-model="formInline.scheduleName"
                  placeholder="请输入会议名称"
                />
              </FormItem>
              <FormItem label="会议地点：">
                <Input
                  v-model="formInline.scheduleAddress"
                  placeholder="请输入会议地点"
                />
              </FormItem>
              <FormItem label="会议链接：">
                <Input
                  v-model="formInline.preRegLink"
                  placeholder="请输入会议链接"
                />
              </FormItem>
              <FormItem label="开始日期：">
                <DatePicker
                  v-model="formInline.beginTime"
                  style="width: 100%"
                  type="date"
                  placeholder="请输入开始时间"
                ></DatePicker>
              </FormItem>
              <FormItem label="结束日期：">
                <DatePicker
                  v-model="formInline.endTime"
                  style="width: 100%"
                  type="date"
                  placeholder="请输入结束时间"
                ></DatePicker>
              </FormItem>
              <FormItem label="起止时间：">
                <Input
                  v-model="formInline.meetingTime"
                  placeholder="请输入起止时间"
                />
              </FormItem>

              <FormItem label="日程图片：">
                <div>
                  <upload
                    ref="upload1"
                    :fileList="uploadBanner"
                    :config="uploadBannerConfig"
                    @upload-ok="bannerOK"
                  />
                </div>
              </FormItem>
              <FormItem label="会议内容：">
                <div ref="editorElement"></div>
              </FormItem>
            </Form>
          </div>
        </div>
        <div slot="footer">
          <Button
            type="primary"
            :loading="loading"
            @click="handleSubmit('formInline')"
            >确定</Button
          >
          <Button @click="cancel">取消</Button>
        </div>
      </iModal>
      <iModal
        title="添加会议"
        v-model="showAdd"
        class-name="vertical-center-modal"
        width="800px"
        :mask-closable="false"
        @on-cancel="cancel"
      >
        <div class="admin-add">
          <div class="admin-add-content">
            <Form
              ref="formInline"
              :model="formInline"
              :rules="ruleInline"
              label-position="right"
              :label-width="100"
              @submit.native.prevent
            >
              <FormItem label="会议名称：">
                <Input
                  v-model="formInline.scheduleName"
                  placeholder="请输入会议名称"
                />
              </FormItem>
              <FormItem label="会议地点：">
                <Input
                  v-model="formInline.scheduleAddress"
                  placeholder="请输入会议地点"
                />
              </FormItem>
              <FormItem label="会议链接：">
                <Input
                  v-model="formInline.preRegLink"
                  placeholder="请输入会议链接"
                />
              </FormItem>
              <FormItem label="开始日期：">
                <DatePicker
                  v-model="formInline.beginTime"
                  type="date"
                  placeholder="请输入开始时间"
                ></DatePicker>
              </FormItem>
              <FormItem label="结束日期：">
                <DatePicker
                  v-model="formInline.endTime"
                  type="date"
                  placeholder="请输入结束时间"
                ></DatePicker>
              </FormItem>
              <FormItem label="起止时间：">
                <Input
                  v-model="formInline.meetingTime"
                  placeholder="请输入起止时间"
                />
              </FormItem>

              <FormItem label="日程图片：">
                <div>
                  <upload
                    ref="upload1"
                    :fileList="uploadBanner1"
                    :config="uploadBannerConfig"
                    @upload-ok="bannerOK"
                  />
                </div>
              </FormItem>
              <FormItem label="会议内容：">
                <div ref="addElement"></div>
              </FormItem>
            </Form>
          </div>
        </div>
        <div slot="footer">
          <Button
            type="primary"
            :loading="loading"
            @click="handleSubmit1('formInline')"
            >确定</Button
          >
          <Button @click="cancel1">取消</Button>
        </div>
      </iModal>
      <iModal
        title="查看图片"
        v-model="visible"
        class-name="vertical-center-modal"
        width="600px"
        footer-hide
      >
        <div style="width: 100%; height: 100%">
          <img style="width: 100%" :src="imgurl" />
        </div>
      </iModal>

      <!--统计表格-->
      <iModal
        title="统计数据"
        v-model="showTable"
        class-name="vertical-center-modal"
        width="800px"
        :mask-closable="false"
        @on-cancel="cancel"
      >
        <Table
          :border="false"
          
          :columns="columns1"
          :data="userList"
          no-data-text="暂无数据"
        >
          <template slot-scope="{ row, index }" slot="name"
            >{{ row.name }}
          </template>
          <template slot-scope="{ row, index }" slot="tel"
            >{{ row.tel }}
          </template>
          <Page
            show-total
            show-elevator
            :page-size="pageSize1"
            :current="pageIndex1"
            :total="totalCount1"
            @on-change="changePage1"
            @on-page-size-change="changePageSize1"
          />
        </Table>
      </iModal>
    </div>
  </div>
</template>

<script>
// import staffAdd from "../components/staff-add.vue";
// import staffEdit from "../components/staff-edit.vue";
import configJson from '@assets/config.json';
import { mapActions, mapGetters } from "vuex";
import upload from "@components/upLoad/upLoad";
import wangeditor from "wangeditor";
import axios from "axios";
export default {
  name: "host-set-staff",
  data() {
    return {
      columns: [
        {
          title: "会议内容",
          key: "scheduleName",
          align: "center",
        },
        {
          title: "会议地点",
          key: "scheduleAddress",
          align: "center",
        },
        {
          title: "会议链接",
          key: "preRegLink",
          align: "center",
        },
        {
          title: "开始日期",
          key: "beginTime",
          align: "center",
        },
        {
          title: "结束日期",
          key: "endTime",
          align: "center",
        },
        {
          title: "起止时间",
          key: "meetingTime",
          align: "center",
        },
        {
          title: "日程图片",
          key: "detailedInformation",
          align: "center",
          slot: "detailedInformation",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      columns1: [
        {
          title: "姓名",
          key: "name",
          align: "center",
          slot: "name",
        },
        {
          title: "电话",
          key: "tel",
          align: "center",
          slot: "tel",
        },
      ],
      groupType: "0",
      show: false,
      editShowFlag: false,
      editInfo: {},
      staffList: [],
      pageSize: 10,
      pageIndex: 1,
      pageSize1:10,
      pageIndex1:1,
      totalCount: 0,
      totalCount1: 0,
      imgurl: "",
      groupList: "",
      loading: false,
      visible: false,
      uploadBanner: [], // 产品图
      uploadBanner1: [],
      uploadList: [],
      showAdd: false,
      config: {
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        limitNum: 1,
      },
      formInline: {
        // form双向绑定
        scheduleName: "",
        scheduleAddress: "",
        preRegLink: "",
        beginTime: "",
        endTime: "",
        meetingTime: "",
        DetailedInformation: "",
        content: "",
      },
      ruleInline: {},
      editor: null,
      showTable: false,
      userList: [],
    };
  },
  components: {
    upload,
    // staffAdd,
    // staffEdit
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
    uploadBannerConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_1";
      config.limitNum = 1;
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
  },
  watch: {},
  created() {
    this.init();
  },
  mounted() {
    this.editor = new wangeditor(this.$refs.editorElement);
    this.editor.customConfig.zIndex = 1;
    // 赋值
    this.editor.customConfig.onchange = (e) => {
      this.formInline.content = e;
    };

    // 上传图片配置
    const that = this;
    this.editor.customConfig.customUploadImg = function (files, insert) {
      // console.log(files)
      files.forEach((item) => {
        let fd = new FormData();
        fd.append("file", item); // 上传的文件： 键名，键值
        axios
          .post(`${configJson.api.reqApi}/api/upload/images`, fd)
          .then((data) => {
            if (data.data.successed) {
              insert(data.data.list[0]);
            } else {
              that.$Message.error("上传失败，请重试！");
            }
          })
          .catch((err) => {
            that.$Message.error("上传失败，请重试！");
            console.log(err.response.data);
          });
      });
    };

    this.editor.customConfig.menus = [
      // 菜单配置
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "strikeThrough", // 删除线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      "link", // 插入链接
      "list", // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "emoticon", // 表情
      "image", // 插入图片
      "table", // 表格
      "code", // 插入代码
      "undo", // 撤销
      "redo", // 重复
    ];
    this.editor.create(); // 创建富文本实例

    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }

    //添加的富文本
    this.addtor = new wangeditor(this.$refs.addElement);
    this.addtor.customConfig.zIndex = 1;
    // 赋值
    this.addtor.customConfig.onchange = (e) => {
      this.formInline.content = e;
    };

    this.addtor.customConfig.customUploadImg = function (files, insert) {
      // console.log(files)
      files.forEach((item) => {
        let fd = new FormData();
        fd.append("file", item); // 上传的文件： 键名，键值
        axios
          .post(`${config.api.reqApi}/api/upload/images`, fd)
          .then((data) => {
            if (data.data.successed) {
              insert(data.data.list[0]);
            } else {
              that.$Message.error("上传失败，请重试！");
            }
          })
          .catch((err) => {
            that.$Message.error("上传失败，请重试！");
            console.log(err.response.data);
          });
      });
    };

    this.addtor.customConfig.menus = [
      // 菜单配置
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "strikeThrough", // 删除线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      "link", // 插入链接
      "list", // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "emoticon", // 表情
      "image", // 插入图片
      "table", // 表格
      "code", // 插入代码
      "undo", // 撤销
      "redo", // 重复
    ];
    this.addtor.create(); // 创建富文本实例

    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  },
  methods: {
    ...mapActions({}),
    async init() {
      let body = {
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [],
          },
        },
      };
      this.$http
        .post(
          `/api/OfflineMeeting/GetOfflineMeetingList`,
          body,
          this.$store.state.header
        )
        .then((res) => {
          console.log(res, "获取成功s");
          if (res.status === 200) {
            res.data.items.forEach((c) => {
              c.beginTime = c.beginTime.substring(0, 10);
              c.endTime = c.endTime.substring(0, 10);
            });
            this.staffList = res.data.items;
            this.pageSize = res.data.pageSize;
            this.pageIndex = res.data.pageIndex;
            this.totalCount = res.data.totalCount;
          }
        });
    },

    editShow(item) {
      // 编辑

      this.editShowFlag = true;
      this.formInline = item;
      if (item.detailedInformation) {
        this.uploadBanner.push(item.detailedInformation);
      }
      this.formInline.content = JSON.parse(item.information);
      this.editor.txt.html(JSON.parse(item.information));
      console.log(item, "item");
    },
    validForm(name) {
      // 验证表单
      console.log(name, "valid");
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline = {
        scheduleName: "",
        scheduleAddress: "",
        preRegLink: "",
        beginTime: "",
        endTime: "",
        meetingTime: "",
        DetailedInformation: "",
      };
      this.editShowFlag = false;
    },
    cancel1() {
      this.$refs["formInline"].resetFields();
      this.formInline = {
        scheduleName: "",
        scheduleAddress: "",
        preRegLink: "",
        beginTime: "",
        endTime: "",
        meetingTime: "",
        DetailedInformation: "",
      };
      this.showAdd = false;
    },
    dateFormat(dateData) {
      var date = new Date(dateData);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + m + "-" + d;
      return time;
    },
    async handleSubmit(name) {
      let form = this.formInline;
      //
      // let valid = await this.validForm(name);
      //
      // if (!valid) return;
      form.beginTime = this.dateFormat(form.beginTime);
      form.endTime = this.dateFormat(form.endTime);
      console.log(form.beginTime, "form");
      let req = {
        Id: form.id,
        SetValues: {
          ScheduleName: form.scheduleName,
          scheduleAddress: form.scheduleAddress,
          PreRegLink: form.preRegLink,
          BeginTime: form.beginTime,
          EndTime: form.endTime,
          MeetingTime: form.meetingTime,
          DetailedInformation: this.uploadBanner[0],
          Information: JSON.stringify(this.formInline.content),
        },
      };
      this.$http
        .put(`/api/OfflineMeeting`, req, this.$store.state.header)
        .then((res) => {
          console.log(res, "修改成功");
          if (res.status === 200 && res.data.successed) {
            this.$Message.success("修改成功");
            this.editShowFlag = false;
            this.uploadBanner = [];
            this.init();
          } else {
            this.$Message.error("修改失败");
          }
        });
    },
    async handleSubmit1() {
      let form = this.formInline;
      form.beginTime = this.dateFormat(form.beginTime);
      form.endTime = this.dateFormat(form.endTime);
      let req = {
        scheduleName: form.scheduleName,
        scheduleAddress: form.scheduleAddress,
        preRegLink: form.preRegLink,
        beginTime: form.beginTime,
        endTime: form.endTime,
        showIndex: "61",
        meetingTime: form.meetingTime,
        DetailedInformation: this.uploadBanner1[0],
        Information: JSON.stringify(this.formInline.content),
      };
      this.$http
        .post(`/api/OfflineMeeting`, req, this.$store.state.header)
        .then((res) => {
          console.log(res, "添加成功");
          if (res.status === 200 && res.data.successed) {
            this.editShowFlag = false;
            this.init();
            this.$Message.success("添加成功");
            this.showAdd = false;
          } else {
            this.$Message.error("添加失败，请重新尝试");
          }
        });
    },
    bannerOK(list) {
      //console.log("ok", list);
      this.uploadBanner = list;
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    //会议报名人数表格
    changePage1(e) {
      this.pageIndex1 = e;
      this.TableShow();
    },
    changePageSize1(e) {
      this.pageSize1 = e;
      this.TableShow();
    },
    delItem(row) {
      console.log(row, "row");
      let id = row.id;
      this.$http
        .delete(`/api/OfflineMeeting?id=${id}`, this.$store.state.header)
        .then((res) => {
          console.log(res, "刪除成功");
          if (res.status === 200 && res.data.successed) {
            this.$Message.success("删除成功");
            this.init();
          } else {
            this.$Message.error("刪除失败，请重新尝试");
          }
        });
    },
    TableShow(row) {
      this.showTable = true;
      let id = row.id;
      let opt = {
        PageSize: this.pageSize1,
        PageIndex: this.pageIndex1,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 0,
                  Label: "wOfflineMeetingId",
                  Value: id,
                },
              },
            ],
          },
        },
      };
      this.$http
        .post(
          `/api/OfflineMeeting/GetJoinPagedList`,
          opt,
          this.$store.state.header
        )
        .then((res) => {
          console.log(res, "查询结果");
          if (res.status === 200) {
            if (res.data.items.length > 0) {
              this.userList = res.data.items;
            }
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.label {
  min-width: 1000px;
  min-height: 500px;
  padding: 30px;
}
</style>
